import { render } from "./TransactionsNewView.vue?vue&type=template&id=2a950771&scoped=true"
import script from "./TransactionsNewView.vue?vue&type=script&lang=js"
export * from "./TransactionsNewView.vue?vue&type=script&lang=js"

import "./TransactionsNewView.vue?vue&type=style&index=0&id=2a950771&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a950771"]])

export default __exports__